var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dividing"},[(_vm.line)?_c('div',{staticClass:"line",style:({
      borderColor: _vm.borderColor
    })}):_c('div',{staticClass:"blank",style:({
      height: _vm.blankHeight + 'px'
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }